<div class="topbar container-fluid">
  <div class="d-flex align-items-center gap-lg-2 gap-1">
    <div class="logo-topbar">
      <a [routerLink]="['/home']" class="logo-light">
        <span class="logo-lg">
          <img src="../../../assets/images/v2/svg/logo.svg" alt="logo" />
        </span>
        <span class="logo-sm">
          <img
            src="../../../assets/images/v2/svg/logo-sm.svg"
            alt="small logo"
          />
        </span>
      </a>

      <a [routerLink]="['/home']" class="logo-dark">
        <span class="logo-lg">
          <img
            src="../../../assets/images/v2/svg/logo-dark.svg"
            alt="dark logo"
          />
        </span>
        <span class="logo-sm">
          <img
            src="../../../assets/images/v2/svg/logo-dark-sm.svg"
            alt="small logo"
          />
        </span>
      </a>
    </div>

    <button class="button-toggle-menu" (click)="toggleSidenav()">
      <i class="mdi mdi-menu"></i>
    </button>

    <button
      class="navbar-toggle"
      data-bs-toggle="collapse"
      data-bs-target="#topnav-menu-content"
    >
      <div class="lines">
        <span></span>
        <span></span>
        <span></span>
      </div>
    </button>
  </div>

  <div class="page-title-box text-truncate me-auto">
    <h4 class="page-title mb-0">
      @if (
        (isAdmin() || isSupervisor()) &&
        getCompanyCurrentUser().overdueNonPayment?.overdue
      ) {
        <span class="ms-1 badge font-16 bg-danger">
          Identificamos uma pendência financeira.
          <a
            class="link-warning"
            href="http://wa.me/556199925827?text=Gostaria%20de%20falar%20com%20o%20Financeiro!"
            target="_blank"
            >Clique aqui</a
          >
          para regularizar e evite a perda de acesso. <br />
          O seu acesso será bloqueado em
          {{
            $safeNavigationMigration(getCompanyCurrentUser().overdueNonPayment?.overdueDeadlineAt)
              | timezoneDate: "DD/MM/YYYY" : getTimezoneCompanyCurrentUser()
          }}. <br />
        </span>
      } @else {
        <img
          [src]="getCompanyImage(getCompanyCurrentUser())"
          class="mb-1 me-1 rounded"
          height="24"
          alt="Brandon Smith"
          (error)="onImageError($event)"
        />
        {{ getNameCompanyCurrentUser() }}
      }
    </h4>
  </div>

  <!-- Trial Banner -->
  @if (this.company?.trial?.activated) {
    <trial-button
      [daysRemaining]="daysRemaining"
      [expired]="expired"
      (upgradeClick)="openPlansModal()"
    >
    </trial-button>
  }

  <ul class="topbar-menu d-flex align-items-center gap-3">
    <!-- Minimized call pill — appears only while a call is in progress and the modal is minimized -->
    @if ((softphone.inProgress$ | async) && (softphone.minimized$ | async)) {
      <li>
        <div
          class="softphone-pill"
          role="button"
          tabindex="0"
          [title]="'softphone.pill.reopen' | translate"
          [attr.aria-label]="
            'softphone.pill.reopenWith'
              | translate
                : {
                    name:
                      softphone.activeContact?.name ||
                      softphone.activeContact?.phone
                  }
          "
          (click)="softphone.restore()"
          (keydown.enter)="softphone.restore()"
          (keydown.space)="$event.preventDefault(); softphone.restore()"
        >
          <span
            class="softphone-pill__dot"
            [class.is-ringing]="(softphone.state$ | async) !== 'incall'"
          ></span>
          <span class="softphone-pill__name">
            {{
              softphone.activeContact?.name || softphone.activeContact?.phone
            }}
          </span>
          <span class="softphone-pill__time">
            @if ((softphone.state$ | async) === "incall") {
              {{ softphone.formatDuration((softphone.duration$ | async) ?? 0) }}
            } @else {
              {{ 'softphone.callDialog.ringing' | translate }}
            }
          </span>
          <button
            type="button"
            class="softphone-pill__hangup"
            [title]="'softphone.pill.hangup' | translate"
            [attr.aria-label]="'softphone.pill.hangupAria' | translate"
            (click)="hangupCall($event)"
          >
            <i class="ri-phone-fill"></i>
          </button>
        </div>
      </li>
    }
    <li>
      <div class="nav-link">
        <button
          [matTooltip]="'layout.header.knowledgeBase' | translate"
          class="btn btn-icon btn-sm bg-secondary-lilas position-relative"
          (click)="goToSupport()"
          data-bs-toggle="tooltip"
          data-bs-placement="left"
          [title]="'layout.header.knowledgeBase' | translate"
        >
          <i class="uil-video font-22"></i>
          @if (showSupportBadge) {
            <span
              class="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger font-10"
            >
              {{ 'layout.header.newBadge' | translate }}
            </span>
          }
        </button>
      </div>
    </li>
    <!-- Improvements ranking — a company has one vote per request, so only its managers get here.
         Hidden below md: the topbar has no room for one more icon there. -->
    @if (isAdmin() || isSupervisor()) {
      <li class="d-none d-md-inline-block">
        <div class="nav-link">
          <button
            [matTooltip]="'layout.header.improvements' | translate"
            [attr.aria-label]="'layout.header.improvements' | translate"
            class="btn btn-icon btn-sm bg-secondary-lilas position-relative"
            (click)="openImprovementRanking()"
          >
            <i class="ri-lightbulb-flash-line font-22"></i>
            @if (showImprovementBadge) {
              <span
                class="position-absolute top-0 start-100 translate-middle badge text-bg-warning"
              >
                {{ 'layout.header.newBadge' | translate }}
              </span>
            }
          </button>
        </div>
      </li>
    }
    <li>
      <div class="nav-link">
      <button
        [matTooltip]="'layout.header.messageNotification' | translate"
        class="btn btn-icon btn-sm bg-secondary-lilas"
        (click)="toggleAudio()"
        data-bs-toggle="tooltip"
        data-bs-placement="left"
        [title]="'layout.header.messageNotification' | translate"
      >
        @if (isAudioOn) {
          <span>
            <i class="ri-volume-up-line font-22"></i>
          </span>
        }

        @if (!isAudioOn) {
          <span>
            <i class="ri-volume-mute-line font-22"></i>
          </span>
        }
      </button>
      </div>
    </li>
    <li class="dropdown notification-list">
      <a
        #notificationDropdownToggle
        [ngClass]="{ show: isDropdownMenuOpened }"
        [ngStyle]="{
          'pointer-events': pager.list.length === 0 ? 'none' : '',
          opacity: pager.list.length === 0 ? '0.5' : '',
        }"
        class="nav-link dropdown-toggle arrow-none"
        data-bs-toggle="dropdown"
        href="#"
        role="button"
        aria-haspopup="false"
        aria-expanded="false"
        (click)="toggleDropdownMenu($event)"
      >
        <i class="ri-notification-3-line font-22"></i>
        @if (pager.list.length > 0) {
          <span class="noti-icon-badge"></span>
        }
      </a>
      <div
        #notificationDropdownMenu
        [ngClass]="{ show: isDropdownMenuOpened }"
        class="dropdown-menu dropdown-menu-end dropdown-menu-animated dropdown-lg py-0"
      >
        <div
          class="p-2 border-top-0 border-start-0 border-end-0 border-dashed border"
        >
          <div class="row align-items-center">
            <div class="col">
              <h6 class="m-0 font-16 fw-semibold">{{ 'layout.header.notifications' | translate }}</h6>
            </div>
            <!-- <div class="col-auto">
              <a
                href="javascript: void(0);"
                class="text-dark text-decoration-underline"
              >
                <small>Limpar tudo</small>
              </a>
            </div> -->
          </div>
        </div>

        <div class="simple-scrollbar">
          @for (
            notification of pager.list;
            track $index;
            let firstItem = $first
          ) {
            <h5
              class="text-muted font-13 fw-normal mt-0"
              [ngClass]="{ 'pt-4': firstItem }"
            >
              {{ $safeNavigationMigration(notification?.createdAt) | date: "dd/MM/yyy" }}
            </h5>

            <a
              href="javascript:void(0);"
              class="dropdown-item p-0 notify-item read-noti shadow-none mb-2"
              [routerLink]="['/notification']"
            >
              <div class="card-body" [routerLink]="['/notification']">
                <!-- <span class="float-end noti-close-btn text-muted"
                  ><i class="mdi mdi-close"></i
                ></span> -->
                <div class="d-flex align-items-center">
                  <div class="flex-shrink-0">
                    <div class="notify-icon bg-primary">
                      <i class="mdi mdi-comment-account-outline"></i>
                    </div>
                  </div>
                  <div class="flex-grow-1 text-truncate ms-2">
                    <h5 class="noti-item-title fw-semibold font-14">
                      {{ notification.title }}
                    </h5>
                    <small
                      class="noti-item-subtitle text-muted"
                      [innerHTML]="notification.description | truncate: 55"
                    ></small>
                  </div>
                </div>
              </div>
            </a>
          }
          <a routerLink="/notification"
            class="d-flex justify-content-center align-items-center p-3 text-decoration-none text-primary">
            {{ 'layout.header.seeMore' | translate }}
          </a>
        </div>
      </div>
    </li>

    <li>
      <div class="nav-link">
        <button
          matTooltip="Tarefas"
          class="btn btn-icon btn-sm bg-secondary-lilas"
          data-bs-toggle="tooltip"
          data-bs-placement="left"
          (click)="goToTaskCurrentUser()"
        >
          <i class="ri-task-line font-22"></i>
        </button>
      </div>
    </li>

    <app-language-picker></app-language-picker>

    <li class="d-none d-sm-inline-block">
      <div
        class="nav-link"
        id="light-dark-mode"
        data-bs-toggle="tooltip"
        data-bs-placement="left"
        title="Theme Mode"
        (click)="toggleColorTheme()"
      >
        <i class="ri-moon-line font-22"></i>
      </div>
    </li>
    <li class="dropdown">
      <a
        #userDropdownToggle
        class="nav-link dropdown-toggle arrow-none nav-user px-2"
        data-bs-toggle="dropdown"
        href="#"
        role="button"
        aria-haspopup="false"
        aria-expanded="false"
        (click)="toggleUserDropdown($event)"
      >
        @if (currentUser?.image) {
          <span class="account-user-avatar">
            <img
              [src]="$safeNavigationMigration(currentUser?.image)"
              [matTooltip]="currentUser.name"
              width="32"
              (error)="onImageError($event)"
              class="rounded-circle"
            />
          </span>
        }
        <span class="d-lg-flex flex-column gap-1 d-none">
          <h5 class="my-0">{{ currentUser?.name }}</h5>
          <h6 class="my-0 fw-normal">{{ currentUser?.email }}</h6>
        </span>
      </a>

      <div
        #userDropdownMenu
        class="dropdown-menu dropdown-menu-end dropdown-menu-animated profile-dropdown"
      >
        <div class="dropdown-header noti-title">
          <h5 class="my-0">{{ currentUser?.name }}</h5>
          <h6 class="my-0 fw-normal">{{ currentUser?.email }}</h6>
        </div>

        <hr class="dropdown-divider" />

        <a
          href="javascript:void(0);"
          class="dropdown-item"
          (click)="loadInfos(false)"
        >
          <i class="ri-information-line me-1"></i>
          <span> {{ 'layout.header.communication' | translate }}</span>
        </a>

        <a
          href="javascript:void(0);"
          class="dropdown-item"
          (click)="upadatePassword()"
        >
          <i class="ri-lock-password-line"></i>
          <span> {{ 'layout.header.updatePassword' | translate }}</span>
        </a>

        <a
          href="javascript:void(0);"
          class="dropdown-item"
          (click)="editUserBasicInfo()"
        >
          <i class="ri-edit-line"></i>
          <span> {{ 'layout.header.editUserInfo' | translate }}</span>
        </a>

        @if (isAdmin()) {
        <a href="javascript:void(0);" class="dropdown-item" (click)="editCompanyInfo()">
          <i class="ri-edit-line"></i>
          <span>{{ 'layout.header.editCompanyInfo' | translate }}</span>
        </a>
        }

        @if (isAdmin() && isSubscriptionActive()) {
          <hr class="dropdown-divider" />
          <a
            href="javascript:void(0);"
            class="dropdown-item"
            (click)="goToBilling()"
          >
            <i class="ri-money-dollar-circle-line me-1"></i>
            <span>{{ 'layout.header.billing' | translate }}</span>
          </a>
        }

        <hr class="dropdown-divider" />
        <a
          href="javascript:void(0);"
          class="dropdown-item"
          (click)="openMobileAppModal()"
        >
          <i class="ri-smartphone-line me-1"></i>
          <span>{{ 'layout.header.mobileApp' | translate }}</span>
        </a>

        <a
          href="javascript:void(0);"
          class="dropdown-item"
          (click)="openAboutModal()"
        >
          <i class="ri-information-line me-1"></i>
          <span>{{ 'layout.header.about' | translate }}</span>
        </a>

        <hr class="dropdown-divider" />
        <a href="javascript:void(0);" class="dropdown-item" (click)="logout()">
          <i class="mdi mdi-logout me-1"></i>
          <span>{{ 'layout.header.logout' | translate }}</span>
        </a>
      </div>
    </li>
  </ul>
</div>
